import {TranslateLoader} from '@ngx-translate/core';
import {Observable} from 'rxjs/Observable';
import {ApiService, Logger} from '../services';
import {Translations} from '../models';
import {map} from 'rxjs/operators';
import {ApiResponse} from '../services/api.service';
import {Inject, Injector} from '@angular/core';
import {LocaleConfig} from '../utils/config';

export function HttpLoaderFactory(api: ApiService, localeConfig: LocaleConfig) {
    return new LocaleTranlationsLoader(api, localeConfig);
}

export class LocaleTranlationsLoader implements TranslateLoader {

    private translations: Translations = null;

    constructor(@Inject(ApiService)private api: ApiService, @Inject(LocaleConfig)private localeConfig: LocaleConfig) {
    }

    getTranslation(lang: string): Observable<any> {
        return Observable.create((observer) => {
            if (this.translations === null) {
                this.loadTranslations().subscribe((translations: Translations) => {
                    this.translations = translations;
                    observer.next(translations.translations);
                });
            } else {
                observer.next(this.translations.translations);
            }
        });
    }

    private loadTranslations(): Observable<Translations> {
        let section = this.localeConfig.SECTION !== undefined ? this.localeConfig.SECTION : 'webconfigurator';
        return this.api.get('/configurator/localization/' + this.getCurrentLocale() + '/' + section).pipe(map((data: ApiResponse) => {
            return data.result;
        }));
    }

    /**
     * Get current locale or default one
     * @returns {string}
     */
    public getCurrentLocale() {
        let languages = window.navigator.languages || [window.navigator.language];
        let locale = languages.find((l) => l.match(/^[a-z]{2}-[A-Z]{2}$/) !== null);
        if (!locale) {
            locale = this.localeConfig.DEFAULT_LOCALE;
        }
        return locale;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/utils/LocaleTranlationsLoader.ts